import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AboutInfo } from "abweb/dto/generated/about/AboutInfo";
import { MethodType } from "abweb/service/rpc/MethodType";
import { ExtensionPoints } from "abweb/utils/plugins/ExtensionPoints";

/** Extension Point for client-side about info providers */

export class AboutService {
  constructor(rpcService) {
    _defineProperty(this, "rpcService", void 0);
    this.rpcService = rpcService;
  }
  async getAboutInfo() {
    return this.rpcService.invokeRetObj("/api/abweb/about/aboutInfo", null, AboutInfo, MethodType.GET).then(async serverAboutInfo => {
      // collect all the client-side about items
      let clientAboutInfoItems = [];
      for (const loader of await AboutService.ABOUT_INFO_LOADERS.get()) {
        const items = await loader.load();
        clientAboutInfoItems = [...clientAboutInfoItems, ...items];
      }
      if (serverAboutInfo && serverAboutInfo.items) {
        // server info comes first
        serverAboutInfo.items = [...serverAboutInfo.items, ...clientAboutInfoItems];
      } else if (serverAboutInfo) {
        // no items from the server, use the client
        serverAboutInfo.items = clientAboutInfoItems;
      } else {
        // no response from the server, use the client
        serverAboutInfo = AboutInfo.createAboutInfo(clientAboutInfoItems);
      }
      return serverAboutInfo;
    });
  }
}
/** extension point allowing clients to create AboutInfos */
_defineProperty(AboutService, "ABOUT_INFO_LOADERS", ExtensionPoints.multiValue());
//# sourceMappingURL=AboutService.js.map
